import { render, staticRenderFns } from "./QuestionTranslationRow.vue?vue&type=template&id=4861abdd&scoped=true&"
import script from "./QuestionTranslationRow.vue?vue&type=script&lang=js&"
export * from "./QuestionTranslationRow.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTranslationRow.vue?vue&type=style&index=0&id=4861abdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861abdd",
  null
  
)

export default component.exports